<template>
  <div class="flex-1 overflow-y-auto mb-2 pr-1" style="min-height: 0;">
    <div v-if="carrito.length === 0" class="text-center text-500 py-4 font-medium">
      El pedido está vacío.
    </div>
    
    <div v-else class="flex flex-column gap-2">
      <div 
        v-for="(data, idx) in carritoVisual" 
        :key="idx"
        class="flex align-items-center justify-content-between p-2 border-round-xl surface-border border-1 bg-white"
      >
        <!-- Item Info -->
        <div class="flex flex-column flex-1 overflow-hidden pr-2">
          <span class="font-bold line-height-3 text-800 text-2xl white-space-wrap text-overflow-ellipsis overflow-hidden">
            {{ data.nombre }}</span>
          <span class="text-xl text-500 font-bold mt-1" v-if="!data.es_smart_combo">Bs. {{ data.precioBase }}</span>
          <div class="flex flex-column mt-1" v-if="data.es_smart_combo && data.subItems">
            <span v-for="sub in data.subItems" :key="sub.id" class="text-sm text-500">
              - {{ sub.nombre }}
            </span>
          </div>
          <div class="flex flex-wrap gap-1 mt-1">
            <!-- Bordes Seleccionados -->
            <template v-if="data.bordes_seleccionados && data.bordes_seleccionados.length > 0">
              <ZapiPizzaTag 
                v-for="borde in data.bordes_seleccionados" 
                :key="'borde_' + borde.id" 
                :label="`Borde: ${borde.nombre}`" 
                :active="true" 
                style="background-color: #e0e7ff; color: #3730a3; border-color: #c7d2fe;"
              />
            </template>

            <!-- Extras Seleccionados -->
            <template v-if="data.extras_seleccionados && data.extras_seleccionados.length > 0">
              <ZapiPizzaTag 
                v-for="extra in data.extras_seleccionados" 
                :key="'extra_' + extra.id" 
                :label="`Extra: ${extra.nombre}`" 
                :active="true" 
                style="background-color: #fef08a; color: #854d0e; border-color: #fde047;"
              />
            </template>

            <!-- Salsas -->
            <template v-for="salsa in salsasDisponibles" :key="salsa.id">
              <ZapiPizzaTag 
                v-if="data['salsa_' + salsa.id] > 0" 
                :label="`${salsa.nombre} x${data['salsa_' + salsa.id]}`" 
                :active="true" 
              />
            </template>
          </div>
        </div>

        <!-- Stepper Cantidad -->
        <ZapiStepper 
          :cantidad="data.cantidad"
          @sumar="$emit('sumarCantidad', data.originalIndex)"
          @restar="$emit('restarCantidad', data.originalIndex)"
          @editar="$emit('editarCantidad', data.originalIndex)"
          v-if="!data.es_smart_combo"
        />
        <div v-else class="w-7rem flex justify-content-center"></div>

        <!-- Total & Actions -->
        <div class="flex align-items-center pl-2 border-left-1 surface-border ml-1">
          <span class="font-bold text-2xl text-900 w-6rem text-right mr-2" v-if="!data.es_smart_combo">Bs. {{ (data.precioBase * data.cantidad).toFixed(2) }}</span>
          <span class="font-bold text-2xl text-900 w-6rem text-right mr-2" v-else>Bs. {{ data.precioTotalCombo.toFixed(2) }}</span>
          
          <div class="flex flex-column gap-1">
            <Button v-if="data.requiere_modal === true" icon="pi pi-pencil" class="p-button-text p-button-info p-button-rounded p-button-sm m-0 p-1 h-2rem w-2rem" @click="$emit('editarSalsas', data.originalIndex)" v-tooltip.left="'Editar Opciones'" />
            <Button icon="pi pi-times" class="p-button-text p-button-danger p-button-rounded p-button-sm m-0 p-1 h-2rem w-2rem" @click="$emit('eliminar', data.originalIndex, data.combo_group_id)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ZapiPizzaTag from '../atoms/ZapiPizzaTag.vue';
import ZapiStepper from '@/components/shared/ZapiStepper.vue';

export default {
  name: 'ZapiCartTable',
  components: { ZapiPizzaTag, ZapiStepper },
  props: {
    carrito: {
      type: Array,
      required: true
    },
    salsasDisponibles: {
      type: Array,
      default: () => []
    }
  },
  emits: ['editarCantidad', 'eliminar', 'editarSalsas', 'sumarCantidad', 'restarCantidad'],
  computed: {
    carritoVisual() {
      const visual = [];
      const combosMap = {};

      this.carrito.forEach((item, originalIndex) => {
        if (item.es_smart_combo) {
          const cloned = { ...item, originalIndex, subItems: [], precioTotalCombo: 0 };
          combosMap[item.combo_group_id] = cloned;
          visual.push(cloned);
        } else if (item.combo_group_id) {
          const combo = combosMap[item.combo_group_id];
          if (combo) {
            combo.subItems.push({ ...item, originalIndex });
            combo.precioTotalCombo += (item.precioBase * item.cantidad);
          } else {
            visual.push({ ...item, originalIndex });
          }
        } else {
          visual.push({ ...item, originalIndex });
        }
      });
      return visual;
    }
  }
}
</script>
<style scoped>
</style>